import { Controller } from "@hotwired/stimulus";
import { clearError, showError } from "./client_side_validations_controller";

const MISMATCH = "doesn't match Password";

// Connects to data-controller="password-confirmation"
export default class extends Controller {
  static targets = ["password", "confirmation"];

  validate(event) {
    if (this.check()) return;

    event.preventDefault();
    this.confirmationTarget.focus();
  }

  revalidate() {
    const confirmation = this.confirmationTarget;
    if (!this.checked) return;
    if (confirmation.value || confirmation.hasAttribute("aria-invalid"))
      this.check();
  }

  check() {
    this.checked = true;
    const confirmation = this.confirmationTarget;
    const matches = confirmation.value === this.passwordTarget.value;

    if (matches) clearError(confirmation);
    else showError(confirmation, MISMATCH, confirmation.parentElement);
    return matches;
  }
}
